import React from "react";
import { connect } from "react-redux";
import styled, { keyframes, withTheme } from "styled-components";
import NullCloud1 from "../../../components/icons/NullCloud1";
import NullCloud2 from "../../../components/icons/NullCloud2";
import NullCloud3 from "../../../components/icons/NullCloud3";
import NullCloud4 from "../../../components/icons/NullCloud4";
import NullCloud5 from "../../../components/icons/NullCloud5";
import { t } from "../../../core/translate";
import {
  styledMedia,
  jsQueries
} from "../../../components/mediaquery/breakpoints";
import withMatchMedia from "../../../components/mediaquery/with-match-media";
import NullConstructionDesktop from "../../../components/icons/NullConstructionDesktop";
import NullConstructionMobile from "../../../components/icons/NullConstructionMobile";
import Banner from "../banner";
import ActionBlocks from "../action-blocks";
import { selectors as bridgeSelectors } from "../../../../redux/bridge";
import { selectors as brandSelectors } from "../../../../redux/brand";
import { actions as routerActions } from "../../../../redux/router";
import Spinner from "../../../components/spinner/centered-spinner";
import HeroTitle from "../explorer-tab/hero-title";
import ExpiredBooksLane from "../library-tab/expired-books-lane";
import PromotionSwimLane from "../promotions-lane";
import PromotionGrid from "../promotions-lane/promotion-grid";
import { studentBannerPadding } from "../../../components//mixins";

const CloudAnimationKeyframes = keyframes`
  0% { transform: translate(0%,0%); }
  25% { transform: translate(5%,15%); }
  50% { transform: translate(10%,5%); }
  75% { transform: translate(0%,15%); }
  100% { transform: translate(0%,0%); }
`;

const StyledNullScreen = styled.div`
  overflow: hidden;
  ${props =>
    studentBannerPadding(props.showStudentBanner, props.isSmall, props.native)};
`;

const SpinnerBackground = styled.div`
  height: 450px;
`;

const Background = styled.div`
  overflow: hidden;
  position: absolute;
  left: 0;
  right: 0;
  height: 450px;
  .circle {
    position: absolute;
    border-radius: 0 0 80% 80%/ 0 0 50% 50%;
    background: ${props => props.theme.color.base.getShade(8)};
    z-index: 0;
    top: 0;
    left: -100px;
    right: -100px;
    height: 100%;
  }
`;

const AnimationContainer = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 360px;
  position: relative;
  margin-bottom: 50px;
  ${styledMedia.medium`
    flex-direction: row;
  `}
  ${styledMedia.small`
    margin-bottom: 10em;
    flex-direction: column;
  `}
`;

const HeadingBlock = styled.div`
  color: #ffffff;
  max-width: 360px;
  margin-left: 195px;
  margin-top: 30px;
  button {
    margin-left: 25px;
  }
  ${styledMedia.medium`
      margin-left: 95px;
  `}
  ${styledMedia.small`
      margin-left: 0;
  `}
`;

const HeadingBlockHeader = styled.h2`
  min-width: 340px;
  max-width: 440px;
  font-weight: 500;
  font-size: 5.8rem;
  padding-bottom: 16px;
  ${styledMedia.small`
    margin: 0px;
    padding: 0 25px 25px 25px;
    font-weight: 600;
    font-size: 32px;
    text-align: left;
  `}
`;

const HeadingBlockParagraph = styled.p`
  font-weight: 400;
  font-size: 1.8rem;
  ${styledMedia.small`
    display: none;
  `}
`;

const CloudAnimation = styled.div`
  ${styledMedia.small`
    display: none;
  `}
  position: absolute;
  animation: ${CloudAnimationKeyframes} ${props => props.time} ease-in-out
    infinite;
`;

const ConstructionContainer = styled.div`
  svg {
    min-width: 300px;
    max-width: 775px;
    transform: scale(0.87);
    ${styledMedia.medium`
      width: 25%;
      transform: none;
    `}
  }
  ${styledMedia.small`
    align-self: flex-end;
    position: relative;
    top: 3rem;
    left: 1em;
  `}
`;

const LaneContainer = styled.div`
  padding-top: 20px;
`;

const renderClouds = mediaQueryMatches => {
  return (
    <AnimationContainer>
      <CloudAnimation style={{ top: 80, left: -10 }} time={"10s"}>
        <NullCloud1 />
      </CloudAnimation>
      <HeadingBlock>
        <HeadingBlockHeader>
          {t("library.start-building", "Start building your library!")}
        </HeadingBlockHeader>
        <HeadingBlockParagraph>
          {t(
            "library.add-books",
            "Add books to your library and easily read across all your devices."
          )}
        </HeadingBlockParagraph>
      </HeadingBlock>
      <CloudAnimation
        style={{ top: 200, left: `calc(100% - ${750}px)` }}
        time={"15s"}
      >
        <NullCloud2 />
      </CloudAnimation>

      <CloudAnimation style={{ top: 60, right: 160 }} time={"20s"}>
        <NullCloud4 />
      </CloudAnimation>
      <CloudAnimation style={{ top: 180, right: 120 }} time={"25s"}>
        <NullCloud3 />
      </CloudAnimation>
      <CloudAnimation style={{ top: 100, right: 0 }} time={"15s"}>
        <NullCloud5 />
      </CloudAnimation>
      <ConstructionContainer className="build-lib">
        {mediaQueryMatches ? (
          <NullConstructionMobile />
        ) : (
          <NullConstructionDesktop />
        )}
      </ConstructionContainer>
    </AnimationContainer>
  );
};

class LibraryNullScreen extends React.Component {
  constructor() {
    super();
    this.state = {
      promotionsExpanded: false
    };
  }
  currentSubVbid = () => {
    const { subscriptionVbids, helpsSubVbids } = this.props;
    return subscriptionVbids.find(
      vbid => !!helpsSubVbids.find(({ vbid: helpsVbid }) => helpsVbid === vbid)
    );
  };

  render() {
    const {
      mediaQueryMatches,
      push,
      bridgeUserFetching,
      enableStudentBanner,
      native
    } = this.props;
    if (this.state.promotionsExpanded) {
      return (
        <PromotionGrid
          onHeaderClick={() =>
            this.setState({
              promotionsExpanded: false
            })
          }
        />
      );
    }
    return (
      <StyledNullScreen
        showStudentBanner={enableStudentBanner}
        isSmall={Fraction.Helpers.isSmallScreen()}
        native={native}
      >
        {bridgeUserFetching ? (
          <SpinnerBackground>
            <Spinner />
          </SpinnerBackground>
        ) : this.currentSubVbid() ? (
          <HeroTitle
            subscriptionVbid={this.currentSubVbid()}
            actionButton={{ label: "Explore", action: () => push("explore") }}
          />
        ) : (
          <div>
            <Background>
              <div className="circle" />
            </Background>
            {renderClouds(mediaQueryMatches)}
          </div>
        )}
        <LaneContainer>
          <ExpiredBooksLane />
        </LaneContainer>
        <ActionBlocks />
        <PromotionSwimLane
          onHeaderClick={() =>
            this.setState({
              promotionsExpanded: true
            })
          }
        />
        <Banner />
      </StyledNullScreen>
    );
  }
}

const mapStateToProps = state => ({
  bridgeUserFetching: bridgeSelectors.isUserFetching(state),
  subscriptionVbids: bridgeSelectors.getBrandedSubscriptionVbids(state) || [],
  helpsSubVbids: brandSelectors.getBrandValue(
    state,
    "Bridge.VSTHelps.subscriptions",
    []
  ),
  enableStudentBanner: brandSelectors.getBrandValue(
    state,
    "StudentHome.enabled"
  )
});

const mapDispatchToProps = dispatch => ({
  push: path => dispatch(routerActions.push(path))
});

export default withTheme(
  withMatchMedia(jsQueries.small)(
    connect(mapStateToProps, mapDispatchToProps)(LibraryNullScreen)
  )
);
